// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_9eU","cls2":"ConfirmationModal-cls2_1Qp ConfirmationModal-cls1_9eU"};